import * as React from "react";
import { useTranslation } from "react-i18next";

import { rotate_svg } from "./rotate-screen-please-elements";

const RotateScreenPlease: React.FC = () => {
  const { t } = useTranslation("global");
  return (
    <div className={`m-rotate-screen-please`}>
      {rotate_svg}
      <p>{t("Rota la pantalla por favor")}</p>
    </div>
  );
};

export default RotateScreenPlease;
